import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index';
import RolesIndex from "../views/roles/Index";
import UsersIndex from "../views/users/Index";
import VehiclesIndex from "../views/vehicles/Index"
import VehiclesUpdate from "../views/vehicles/Update"
import ReportsIndex from "../views/reports/Index"
import IssuesIndex from "../views/issues/Index"
import BookingsIndex from "../views/bookings/Index"
import BookingsUpdate from "../views/bookings/Update"
import Login from "../views/Login";
import NotFound from "../views/NotFound";
import Profile from "../views/Profile";
import {i18n} from '../locale/i18n';
import Reset from "@/views/Reset";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/users'
    },
    {
        path: '/bookings',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: '/',
                name: 'bookings-index',
                component: BookingsIndex,
                meta: {
                    auth: true,
                    all_permissions: ['read bookings'],
                },
            },
            {
                path: ':id',
                name: 'bookings-update',
                component: BookingsUpdate,
                meta: {
                    auth: true,
                    any_permissions: ['read bookings', 'update bookings'],
                }
            }
        ]
    },
    {
        path: '/issues',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: '/',
                name: 'issues-index',
                component: IssuesIndex,
                meta: {
                    auth: true,
                    all_permissions: ['read issues'],
                },
            },
        ]
    },
    {
        path: '/vehicles',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: '/',
                name: 'vehicles-index',
                component: VehiclesIndex,
                meta: {
                    auth: true,
                    all_permissions: ['read vehicles'],
                },
            },
            {
                path: ':id',
                name: 'vehicles-update',
                component: VehiclesUpdate,
                meta: {
                    auth: true,
                    any_permissions: ['read vehicles', 'update vehicles'],
                }
            }
        ]
    },
    {
        path: '/reports',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: '/',
                name: 'reports-index',
                component: ReportsIndex,
                meta: {
                    auth: true,
                    all_permissions: ['read reports'],
                },
            },
        ]
    },
    {
        path: '/roles',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: '/',
                name: 'roles-index',
                component: RolesIndex,
                meta: {
                    auth: true,
                    all_permissions: ['read roles'],
                },
            },
        ]
    },
    {
        path: '/users',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: '/',
                name: 'users-index',
                component: UsersIndex,
                meta: {
                    auth: true,
                    all_permissions: ['read users'],
                },
            },
        ]
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            auth: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            auth: 'guest',
        }
    },
    {
        path: '/password/reset',
        name: 'reset',
        component: Reset,
        meta: {
            auth: 'guest',
        }
    },
    {
        path: '*',
        name: 'notfound',
        component: NotFound,
        meta: {
            auth: false
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});


router.beforeEach(async (to, from, next) => {
    window.scrollTo(0, 0);

    if (!to.meta)
        next();

    // check auth
    if (to.meta.auth) {
        const routeAuth = to.meta.auth;

        if (routeAuth === true) {
            // user must be logged in
            if (!store.getters.token) {
                Vue.notify({
                    type: 'error',
                    text: i18n.t('auth.unauthenticated')
                });

                return next({name: 'login'});
            }
        } else if (routeAuth.toLowerCase() === 'guest') {
            // user must be logged out
            if (store.getters.token)
                return next({path: '/'});
        }
    }

    // check permission
    if (to.meta.any_permissions) {
        // check that the user has some of the required permissions

        if (!store.getters.hasAnyPermission(to.meta.any_permissions)) {
            Vue.notify({
                type: 'error',
                text: i18n.t('auth.unauthorized')
            });

            return next({path: '/'});
        }
    }

    // check permission
    if (to.meta.all_permissions) {
        // check that the user has all the required permissions

        let permissions = to.meta.all_permissions;
        if (!store.getters.hasAllPermissions(permissions)) {
            Vue.notify({
                type: 'error',
                text: i18n.t('auth.unauthorized')
            });

            return next({path: '/'});
        }
    }

    return next();
});

export default router;
